import { useReportModal } from "@hooks/useReportModal";
import BaseModalContent from "../BaseReportModalContent/BaseReportModalContetnt";
import { REPORT_MODAL_NAMES } from "config/labels";
import { useEffect, useRef, useState } from "react";
import EjectionFractionModalContent from "./EjectionFractionReportModalContent";
import { EFProps } from "./EjectionFraction.types";
import { useConfig } from "config/useConfig";
import useModalActions from "@hooks/common/useModalAction";
import { ContextKey, useBufferPool, VRContext } from "@features/analysis/rendering/Panels/Renderers/vtkManagers";
import { useBrowserPage } from "@features/browser/useBrowserPage";
import { captureER } from "utils/captureUtils";
import { usePanelContainer } from "@features/analysis/rendering/Panels/usePanelContainer";

const EjectionFractionModal = ({
  onClose,
}:{
  onClose: ()=>void,
}) => {
  const names = REPORT_MODAL_NAMES.ef;
  const { config, setData } = useConfig();
  const { waitingAction, closeLoadingModal } = useModalActions();
  console.log(config.reportEF)
  const [efData, setEfData] = useState<EFProps>({
    imageSrc: {
      diastolic: undefined as string | undefined,
      systolic: undefined as string | undefined,
    },
    values: {
      lv: {
        ...config.reportEF.LV,
        data: config.reportEF.LV.chamber.map(c => {
          const found = config.reportEF.percents.find(p => p.id === c.id);
          return {
            x: found ? found.value : 0,
            y: c.value,
          };
        }),
      },

       rv: {
        ...config.reportEF.RV,
        data: config.reportEF.RV.chamber.map(c => {
          const found = config.reportEF.percents.find(p => p.id === c.id);
          return {
            x: found ? found.value : 0,
            y: c.value,
          };
        }),
      },
    }
  });

  // const setters = async (angleResults: Record<string, Promise<string>>) => {
  //   const resultEntries = await Promise.all(
  //     Object.entries(angleResults).map(async ([key, promise]) => {
  //       const img = await promise;
  //       return [key, img];
  //     })
  //   );
  //   setEfData(prev => ({
  //     ...prev,
  //     imageSrc: {
  //       ...prev.imageSrc,
  //       ...Object.fromEntries(resultEntries),
  //     },
  //   }));
  // };

  // useEffect(() => {
  //   if (efData.imageSrc?.diastolic && efData.imageSrc?.systolic) {
  //     closeLoadingModal();
  //   } else {
  //     waitingAction({ message: "Waiting" });
  //     scheduleRender("VR", {
  //       type: "captureEF",
  //       keys: ["diastolic", "systolic"],
  //       setters,
  //     });
  //   }
  // }, [efData.imageSrc]);


  const { analysisType } = usePanelContainer();
  const { selectedSeriesId } = useBrowserPage();

  const { contextPool, bufferPool } = useBufferPool();
  const poolRef = useRef(contextPool);
  useEffect(() => {
    poolRef.current = contextPool;
  }, [contextPool]);



  async function capture3d(): Promise<string[] | undefined> {
    const d3context = {
      current: poolRef.current[`VR` as ContextKey] as VRContext,
    } as React.MutableRefObject<VRContext | null>;
    if (!d3context || !selectedSeriesId) return;
    if (!d3context.current) return;

    let urls = await captureER(d3context,bufferPool,analysisType,selectedSeriesId);
    return urls;
  }

  useEffect(() => {
    let alive = true;
    (async () => {
      waitingAction({ message: 'Waiting' });
      try {
        const urls = await capture3d();
        if (alive) {
          setEfData(prev => ({
              ...prev,
              imageSrc: {
              ...prev.imageSrc, // 기존 값 유지
              diastolic: urls![0],
              systolic: urls![1],
            },
          }));
        }
      } finally {
        if (alive) closeLoadingModal();
      }
    })();
    return () => {
      alive = false;
    };
  }, []);


  return(
    <BaseModalContent
      className="ef"
      onClose={onClose}
      vw={55}
      vh={71}
      title={names.title}
    >
      <EjectionFractionModalContent
        imageSrc={efData.imageSrc}
        values={efData.values}
      />
    </BaseModalContent>
  )
}

export function useEFReportModal(res:{updateActivatedTool: (tool: any,check: boolean) => void}) {
  return useReportModal({Component:EjectionFractionModal,...res});
}
